import { useLocation } from 'react-router';

import { isNBAPage } from 'constants/routes';

export const useIsNBAPage = () => {
  const location = useLocation();

  return isNBAPage(location.pathname);
};
